export const AppRoutes = {
  home: "/",
  overview: "/overview",
  login: "/login",
  dashboard: "/dashboard",
  profile: "/profile",
  settings: "/settings",
  verifyEmail: "/verify-email",
  resetPassword: "/reset-password",
  createListing: "/listings/new",
  myListings: "/listings/my",
  listingDetail: (id: string) => `/listings/${id}`,
  verificationRequests: "/verification-requests",
  legal: {
    terms: "/legal/terms",
    partnerTerms: "/legal/partner-terms",
    privacy: "/legal/privacy",
    tokusho: "/legal/tokusho",
  },
};

// Alias for convenience
export const ROUTES = {
  HOME: AppRoutes.home,
  OVERVIEW: AppRoutes.overview,
  LOGIN: AppRoutes.login,
  DASHBOARD: AppRoutes.dashboard,
  PROFILE: AppRoutes.profile,
  SETTINGS: AppRoutes.settings,
  VERIFY_EMAIL: AppRoutes.verifyEmail,
  RESET_PASSWORD: AppRoutes.resetPassword,
  CREATE_LISTING: AppRoutes.createListing,
  MY_LISTINGS: AppRoutes.myListings,
  VERIFICATION_REQUESTS: AppRoutes.verificationRequests,
};
